import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import HoaDeleteDialog from "./HoaDeleteDialog";

const HoaDeleteButton = ({ onDelete, recordId, name }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (isDeleted = false) => {
    if (isDeleted) {
      onDelete();
    }
    setOpen(false);
  };

  return (
    <div>
      <div class="btn_box delt">
      <Button color="secondary" onClick={handleClickOpen} variant="contained">
        Delete The HOA
      </Button>
      <HoaDeleteDialog recordId={recordId} name={name} open={open} onClose={handleClose} />
      </div>
    </div>
  );
}

export default HoaDeleteButton;
